import './src/assets/styles/base.scss'

import wrapWithPr0vider from './provider'
export const wrapRootElement = wrapWithPr0vider